import React from 'react'
import PropTypes from 'prop-types'
import { ContentContainer } from '../Grid'
import { H2, Paragraph } from '../Typography'

import { Colors, Gutter } from '../../utils/styles'

const SectionDashboardDescription = props => (
  <ContentContainer width={[1, 1, 1 / 3]} p={[Gutter.HALF, Gutter.FULL, Gutter.FULL]}>
    <H2 style={{ fontWeight: 500, color: Colors.BLACK }}>{props.title}</H2>
    <Paragraph style={{ marginBottom: 64 }}>{props.description}</Paragraph>
    <div>{props.values}</div>
  </ContentContainer>
)

export default SectionDashboardDescription

SectionDashboardDescription.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  values: PropTypes.node.isRequired,
}
